<!-- Показывает техническое значение в компактном кодовом блоке. -->
<template>
  <span
    class="base-code"
    :class="{ 'base-code--compact': size === 'compact' }"
  >
    <code class="base-code__value"><slot>{{ value }}</slot></code>
    <BaseCopyButton
      v-if="copyable"
      class="base-code__copy"
      :text="copyText"
      :title="copyTitle"
      @copied="$emit('copied', $event)"
    />
  </span>
</template>

<script>
export default {
  name: "BaseCode",

  props: {
    value: {
      type: [String, Number],
      default: "",
    },
    copyable: {
      type: Boolean,
      default: true,
    },
    copyTitle: {
      type: String,
      default: "Скопировать",
    },
    size: {
      type: String,
      default: "default",
      validator: (value) => ["default", "compact"].includes(value),
    },
  },

  emits: ["copied"],

  computed: {
    copyText() {
      return String(this.value ?? "");
    },
  },
};
</script>

<style scoped>
.base-code {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  padding: 3px 4px 3px 8px;
  border: 1px solid #e2e8f0;
  border-radius: 5px;
  background: #f8fafc;
  color: #334155;
}

.base-code__value {
  min-width: 0;
  overflow-wrap: anywhere;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.45;
  white-space: pre-wrap;
}

:deep(.base-code__copy.base-copy-button) {
  width: 24px;
  min-width: 24px;
  height: 24px;
  min-height: 24px;
}

.base-code--compact {
  gap: 2px;
  padding: 1px 3px 1px 5px;
}

.base-code--compact .base-code__value {
  font-size: 11px;
  line-height: 1.3;
}

.base-code--compact :deep(.base-code__copy.base-copy-button) {
  width: 18px;
  min-width: 18px;
  height: 18px;
  min-height: 18px;
}
</style>
